import React from "react";
import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ children }) => {
  const tokenPayload = JSON.parse(localStorage.getItem("tokenPayload"));
  const token = localStorage.getItem("token");
  const user = JSON.parse(localStorage.getItem("user"));

  // Check if user is authenticated
  // Doctors can have role as "" (empty string) or "doctor"
  // Other roles include "admin", "frontdesk"
  const isAuthenticated = token && (
    tokenPayload?.role || // Has a specific role (admin, frontdesk, doctor)
    tokenPayload?.role === "" || // Doctor with empty role
    user?.doctor || // Legacy doctor check
    user?.role // User object has role
  );

  return isAuthenticated ? children : <Navigate to="/login" replace />;
};

export default ProtectedRoute;